// Guarda o login de duas formas:
// - sessionStorage: sessão ATIVA desta aba (isolada de outras abas)
// - localStorage: sessão "base", usada só para logar sozinha uma aba nova
//
// Login normal (usuário + senha) grava nas duas.
// "Login Como" grava só na sessionStorage — fica restrito àquela aba.

function bootstrapSeVazio() {
  if (!sessionStorage.getItem('access_token')) {
    const baseAccess = localStorage.getItem('access_token');
    const baseRefresh = localStorage.getItem('refresh_token');
    if (baseAccess) {
      sessionStorage.setItem('access_token', baseAccess);
      sessionStorage.setItem('refresh_token', baseRefresh || '');
    }
  }
}

export function getAccessToken() {
  bootstrapSeVazio();
  return sessionStorage.getItem('access_token');
}

export function getRefreshToken() {
  bootstrapSeVazio();
  return sessionStorage.getItem('refresh_token');
}

export function setBaseTokens(access, refresh) {
  sessionStorage.setItem('access_token', access);
  sessionStorage.setItem('refresh_token', refresh);
  localStorage.setItem('access_token', access);
  localStorage.setItem('refresh_token', refresh);
}

export function updateAccessTokenAposRefresh(novoAccess) {
  sessionStorage.setItem('access_token', novoAccess);
  if (!isImpersonando()) {
    localStorage.setItem('access_token', novoAccess);
  }
}

export function clearAll() {
  sessionStorage.clear();
  localStorage.removeItem('access_token');
  localStorage.removeItem('refresh_token');
}

export function isImpersonando() {
  return !!sessionStorage.getItem('personificando_nome');
}

export function getPersonificandoNome() {
  return sessionStorage.getItem('personificando_nome');
}

export function iniciarPersonificacao(novoAccess, novoRefresh, nome) {
  const atualAccess = sessionStorage.getItem('access_token');
  const atualRefresh = sessionStorage.getItem('refresh_token');
  sessionStorage.setItem('admin_access_token', atualAccess || '');
  sessionStorage.setItem('admin_refresh_token', atualRefresh || '');
  sessionStorage.setItem('access_token', novoAccess);
  sessionStorage.setItem('refresh_token', novoRefresh);
  sessionStorage.setItem('personificando_nome', nome);
}

export function encerrarPersonificacao() {
  const adminAccess = sessionStorage.getItem('admin_access_token');
  const adminRefresh = sessionStorage.getItem('admin_refresh_token');
  if (!adminAccess) return false;
  sessionStorage.setItem('access_token', adminAccess);
  sessionStorage.setItem('refresh_token', adminRefresh);
  sessionStorage.removeItem('admin_access_token');
  sessionStorage.removeItem('admin_refresh_token');
  sessionStorage.removeItem('personificando_nome');
  return true;
}